// Module
var code = "<h2 id=\"affected-by-a-natural-disaster\">Affected by a Natural Disaster?</h2> <p>View our Affected by Natural Disaster FAQ for more information.</p> ";
// Exports
export default code;